import { __awaiter } from 'tslib';
import * as i0 from '@angular/core';
import { Injectable, Injector, NgModule } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as json5 from 'json5';

import * as ɵngcc0 from '@angular/core';
const configPath = '/assets/settings.json5';
// As of version 5.10.0, tslint cannot recognize decorators in
// association with this rule.
/* tslint:disable:completed-docs */
class AppConfigService {
    constructor(injector) {
        this.injector = injector;
    }
    /** Get the base URL used for all API calls.
     * @returns API base URL.
     */
    get baseUrl() {
        if (this.appConfig) {
            return this.appConfig.baseUrl;
        }
        else {
            // Theoritically this would throw an error but it breaks
            // the package
            return 'not set';
        }
    }
    /** The portion of the URL representing the application name.
     * Example:
     *   - full URL: http://sis.test/ats/dashboard
     *   - baseRoute: ats
     */
    get baseRoute() {
        return this._baseRoute;
    }
    /** Set the portion of the URL representing the application name. */
    set baseRoute(value) {
        if (!value) {
            this._baseRoute = '';
        }
        else if (value[0] === '/') {
            this._baseRoute = value.substring(1);
        }
        else {
            this._baseRoute = value;
        }
    }
    /** Get the full set of application config data.
     * @returns Object with application settings.
     */
    get config() {
        return this.appConfig;
    }
    /** Load configuration data.
     * @param prefix Partial path to add to the beginning of the path to the
     *    location of the settings.json5 file.
     * @param baseUrl Optional parameter send by spense
     * @returns Resolved promise.
     */
    loadAppConfig(prefix = '', baseUrl) {
        return __awaiter(this, void 0, void 0, function* () {
            const http = this.injector.get(HttpClient);
            this.baseRoute = prefix;
            if (baseUrl) {
                const promise = new Promise((resolve, reject) => {
                    this.appConfig = baseUrl;
                    resolve();
                });
                return promise;
            }
            else {
                const settingsPath = prefix + configPath;
                return http.get(settingsPath, { responseType: 'text' })
                    .toPromise()
                    .then((data) => {
                    this.appConfig = json5.parse(data);
                })
                    .catch((err) => {
                    console.error(`[0d56b988] Cannot find file: ${settingsPath}`);
                    console.error(`[0d56b989] Cannot find file error: ${err}`);
                    throw (err);
                });
            }
        });
    }
}
AppConfigService.ɵfac = function AppConfigService_Factory(t) { return new (t || AppConfigService)(ɵngcc0.ɵɵinject(ɵngcc0.Injector)); };
AppConfigService.ɵprov = i0.ɵɵdefineInjectable({ factory: function AppConfigService_Factory() { return new AppConfigService(i0.ɵɵinject(i0.INJECTOR)); }, token: AppConfigService, providedIn: "root" });
AppConfigService.ctorParameters = () => [
    { type: Injector }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AppConfigService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc0.Injector }]; }, null); })();

// As of version 5.10.0, tslint cannot recognize decorators in
// association with this rule.
/* tslint:disable:completed-docs */
class AppConfigModule {
}
AppConfigModule.ɵfac = function AppConfigModule_Factory(t) { return new (t || AppConfigModule)(); };
AppConfigModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: AppConfigModule });
AppConfigModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AppConfigModule, [{
        type: NgModule,
        args: [{
                declarations: [],
                exports: [],
                imports: []
            }]
    }], null, null); })();

/*
 * Public API Surface of lib-ng-app-config
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AppConfigModule, AppConfigService };

